
import React, { useContext } from 'react';

import { ContextWidget } from 'form/Contexed';
import { InputWidget } from 'form/InputWidget';
import Button from "@material-ui/core/Button";
import { FormContext } from "core/FormProvider";
import ClearIcon from "@material-ui/icons/Clear";
import IconButton from "@material-ui/core/IconButton";
import styled from "styled-components";
import {CheckboxWidget} from "form/Checkbox";
import {Grid} from "../../../../ui/Grid";

const Index = styled.div`
  border: 1px solid #333333;
  border-radius: 2px;
  font-weight: bold;
  text-align: center;
  line-height: 24px;
`;

const StyledForm = styled.div`
  margin-bottom: 10px;
`;

const StyledHeader = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 24px auto 1fr;
  align-items: center;
  margin-bottom: 10px;
  
  h3 {
    margin: 0;
    padding: 0;
    font-size: 16px;
  }
`;

const StyledBody = styled.div`
  margin-left: 10px;
  border-left: 1px solid #333333;
  padding: 0 0 20px 20px;
`;


function CarrierBankAccountForm() {
  const formContext = useContext(FormContext);
  const bankAccounts = formContext.item.bank_accounts;

  const onAdd = () => {
    formContext.pushArrayValue('bank_accounts', {
      is_delete: false,
      is_active: bankAccounts.length === 0
    })
  }

  const onDelete = (item, index) => {
    if (item.id) {
      formContext.setValue(`bank_accounts.${index}.is_delete`, true);
    }
    else {
      formContext.removeArrayValue('bank_accounts', index);
    }
  }

  const handleIsActiveChange = (value, index) => {
    let items = formContext.item.bank_accounts;
    items.forEach(item => {
      item.is_active = false
    });
    items[index].is_active = true
    formContext.setValue('bank_accounts', items);
  }

  let number = 1;
  return (
    <>
      {bankAccounts && (
        <>
          {bankAccounts.map((item, index) =>
            <React.Fragment key={index}>
              {!item.is_delete && (
                <StyledForm>
                  <StyledHeader>
                    <div>
                      <Index>{number++}</Index>
                    </div>
                    <h3>Реквизиты</h3>
                    <div>
                      <IconButton size="small" onClick={() => onDelete(item, index)}>
                        <ClearIcon />
                      </IconButton>
                    </div>
                  </StyledHeader>
                  <StyledBody>
                    <div className={'mb-20'}>
                      <ContextWidget
                        name={`bank_accounts.${index}.is_active`}
                        WidgetComponent={CheckboxWidget}
                        widgetProps={{
                          label: 'Активность',
                          required: true,
                          onChange: (value) => handleIsActiveChange(value, index)
                        }}
                      />
                    </div>

                    <ContextWidget
                      name={`bank_accounts.${index}.bank`}
                      WidgetComponent={InputWidget}
                      widgetProps={{
                        label: 'Банк получателя',
                        required: true
                      }}
                    />

                    <ContextWidget
                      name={`bank_accounts.${index}.bik`}
                      WidgetComponent={InputWidget}
                      widgetProps={{
                        label: 'БИК',
                        required: true
                      }}
                    />

                    <ContextWidget
                      name={`bank_accounts.${index}.correspondent_account`}
                      WidgetComponent={InputWidget}
                      widgetProps={{
                        label: 'к/с',
                        required: true
                      }}
                    />

                    <ContextWidget
                      name={`bank_accounts.${index}.checking_account`}
                      WidgetComponent={InputWidget}
                      widgetProps={{
                        label: 'р/с',
                        required: true
                      }}
                    />

                    <ContextWidget
                      name={`bank_accounts.${index}.recipient`}
                      WidgetComponent={InputWidget}
                      widgetProps={{
                        label: 'Получатель',
                        multiline: true,
                        required: true
                      }}
                    />

                  </StyledBody>
                </StyledForm>
              )}
            </React.Fragment>
          )}
        </>
      )}

      <Button
        variant="outlined"
        onClick={() => onAdd()}
      >
        + Добавить реквизиты
      </Button>
    </>
  )
}


export default function CarrierForm() {
  return (
    <>

      <Grid columns={'1fr 1fr'} mobileColumns={'1fr'}>
        <ContextWidget
          name={'inn'}
          WidgetComponent={InputWidget}
          widgetProps={{
            label: 'ИНН'
          }}
        />
        <ContextWidget
          name={'kpp'}
          WidgetComponent={InputWidget}
          widgetProps={{
            label: 'КПП'
          }}
        />
      </Grid>

      <Grid columns={'1fr 1fr'} mobileColumns={'1fr'}>
        <ContextWidget
          name={'director_name'}
          WidgetComponent={InputWidget}
          widgetProps={{
            label: 'ФИО руководителя'
          }}
        />
        <ContextWidget
          name={'head_post'}
          WidgetComponent={InputWidget}
          widgetProps={{
            label: 'Должность руководителя'
          }}
        />
      </Grid>

      <ContextWidget
        name={'address'}
        WidgetComponent={InputWidget}
        widgetProps={{
          label: 'Юридический адрес',
          multiline: true
        }}
      />

      <CarrierBankAccountForm />
    </>
  )
}
